import React from 'react';

import { MENTION_LABEL } from '../../../../../../../../store/dashboard/askAica/constants';

import styles from './MentionDropdown.module.scss';

interface MentionDropdownProps {
    onConfirm: () => void;
}

/**
 * Non-focus-stealing mention suggestion popover.
 * Keyboard navigation (Enter/Tab/Esc) is handled by the textarea's onKeyDown.
 * Click uses onMouseDown + preventDefault() so the textarea never loses focus.
 */
const MentionDropdown: React.FC<MentionDropdownProps> = ({ onConfirm }) => (
    <ul className={styles.Dropdown} role="listbox" aria-label="Mention options">
        <li
            role="option"
            aria-selected={true}
            className={styles.Option}
            onMouseDown={(e) => {
                e.preventDefault(); // prevent textarea blur
                onConfirm();
            }}
        >
            {MENTION_LABEL}
        </li>
    </ul>
);

export default MentionDropdown;
